module.exports = __webpack_public_path__ + "static/media/dott.942ca6c0.webp";